<style>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.toast-container {
  z-index: 9999;
  position: fixed;
  padding: 4px;
  box-sizing: border-box;
  color: #fff;
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container.bottom-right {
  bottom: 1em;
  right: 1em;
}
.toast-container.bottom-left {
  bottom: 1em;
  left: 1em;
}
.toast-container.top-left {
  top: 1em;
  left: 1em;
}
.toast-container.top-right {
  top: 1em;
  right: 1em;
}
.toast-container.top-center {
  top: 1em;
  right: 50%;
  left: 50%;
  transform: translate(-50%, 0);
}
.toast-container.bottom-center {
  bottom: 1em;
  right: 50%;
  left: 50%;
  transform: translate(-50%, 0);
}
.toast-container.center-center {
  top: 50%;
  right: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.toast-container > :not(:last-child) {
  margin-bottom: 10px;
}
</style>

<script>
import { onMount } from "svelte";
import { flip } from "svelte/animate";
import { fly, fade } from "svelte/transition";

// import toasts from "./toasts";
// import { toasts } from "svelte-toasts";

export let toasts;

/**
   * @typedef {'success' | 'info' | 'error' | 'warning'} ToastType
   * @typedef {'bottom-right' | 'bottom-left' | 'top-right' | 'top-left' | 'top-center' | 'bottom-center' | 'center-center'} Placement
   * @typedef {{
      uid: number;
      title?: string;
      description: string;
      duration: number;
      type: ToastType;
      theme?: Theme;
      placement: Placement;
      showProgress?: boolean;
      remove?: Function;
      update?: Function;
      onRemove?: Function;
      onClick?: Function;
    }} ToastProps
   */

/**
 * Default theme for all toasts
 * @type { Theme }
 */
export let theme = "dark";

/**
 * Default placement for all toasts
 * @type { Placement }
 */
export let placement = "top-right";

/**
 * Default type of all toasts
 * @type { ToastType }
 */
export let type = "info";

/**
 * Show progress if showProgress is true and duration is greater then 0
 * @type { boolean }
 */
export let showProgress = false;
/**
 * Default duration for all toasts to auto close. 0 to disable auto close
 * @type { number }
 */
export let duration = 500;
/**
 * Width of all toasts
 * @type { string }
 */
export let width = "320px";

/**
 * Default slot which is Toast component/template which will get toast data
 * @slot {{ data: ToastProps }}
 */

const placements = [
  // "bottom-right",
  // "bottom-left",
  "top-right",
  // "top-left",
  // "top-center",
  // "bottom-center",
  // "center-center",
];
const animateMapOut = {
  "bottom-right": { fn: fly, duration, x: 50 },
  "top-right": { fn: fly, duration, x: 50 },
  "bottom-left": { fn: fly, duration, x: -50 },
  "top-left": { fn: fly, duration, x: -50 },
  "bottom-center": { fn: fly, duration, y: 50 },
  "top-center": { fn: fly, duration, y: -50 },
  "center-center": { fn: fade, duration },
};

const animateMapIn = {
  "bottom-right": { fn: fly, duration, x: 50 },
  "top-right": { fn: fly, duration, x: 50 },
  "bottom-left": { fn: fly, duration, x: -50 },
  "top-left": { fn: fly, duration, x: -50 },
  "bottom-center": { fn: fly, duration, y: 50 },
  "top-center": { fn: fly, duration, y: -50 },
  "center-center": { fn: fade, duration },
};

onMount(() => {
  toasts.setDefaults({
    placement,
    showProgress,
    theme,
    duration,
    type,
  });
});

function animate(node, options) {
  return options.fn(node, options);
}

// let _placements = [];
// $: _placements = $toasts.map((n) => n.placement).filter((v, i, a) => a.indexOf(v) == i);
// $: console.log("_placements", _placements);
</script>

{#each placements as placement, index ((index, placement))}
  <div class="toast-container {placement}" style="width: {width}">
    <ul>
      {#each $toasts.filter((n) => n.placement === placement).reverse() as toast (toast.uid)}
        <li animate:flip out:animate={animateMapOut[toast.placement]} in:animate={animateMapIn[toast.placement]}>
          {#if toast.component}
            <svelte:component this={toast.component} data={toast} />
          {:else}
            <slot data={toast} />
          {/if}
        </li>
      {/each}
    </ul>
  </div>
{/each}
